import Tab from 'bootstrap/js/dist/tab';

const tabHash = () => {
	console.log('tabHash inizializzato');
	
	// Verifica che gli elementi esistano
	const tabContainer = document.querySelector('.tabHash');
	if (!tabContainer) {
		console.log('Container .tabHash non trovato');
		return;
	}
	console.log('Container .tabHash trovato:', tabContainer);
	
	// Calcola l'offset dell'header (usando la stessa logica di header.js)
	const getHeaderOffset = () => {
		const breakpoint = { desktop: 1199 };
		const isDesktop = window.innerWidth > breakpoint.desktop;
		
		let headerOffset = 0;
		
		if (isDesktop) {
			// Desktop: usa l'header principale
			const header = document.querySelector(".site-header");
			if (header) {
				headerOffset = header.offsetHeight;
			}
		} else {
			// Mobile: usa l'header mobile
			const headerMobile = document.querySelector(".site-header");
			if (headerMobile) {
				headerOffset = headerMobile.offsetHeight;
			}
		}
		
		// Aggiungi padding extra per sicurezza
		headerOffset += 20;
		
		console.log('Header offset calcolato:', headerOffset);
		return headerOffset;
	};
	
	// Funzione per attivare una tab dall'hash nell'URL
	const activateTabFromHash = (hash = null, shouldScroll = false) => {
		// Usa l'hash passato, quello nell'URL, o quello salvato in sessionStorage
		const targetHash = hash || window.location.hash || sessionStorage.getItem('tabHash');
		console.log('Hash da usare:', targetHash);
		
		if (!targetHash) {
			console.log('Nessun hash trovato');
			return;
		}
		
		// Cerca sia nei link <a> che nei button con data-target o href
		let targetTab = document.querySelector(`.tabHash a[href="${targetHash}"]`);
		if (!targetTab) {
			targetTab = document.querySelector(`.tabHash button[data-target="${targetHash}"]`);
		}
		if (!targetTab) {
			targetTab = document.querySelector(`.tabHash button[href="${targetHash}"]`);
		}
		
		console.log('Tab trovata:', targetTab);
		
		if (!targetTab) {
			console.log('Tab non trovata per hash:', targetHash);
			// Prova a cercare per posizione se non trova per hash
			const hashToIndex = {
				'#request-info': 0,
				'#send-reports': 1,
				'#contact-offices': 2,
				'#contact-facilities': 3
			};
			
			const index = hashToIndex[targetHash];
			if (index !== undefined) {
				const tabs = document.querySelectorAll('.tabHash .nav-link');
				if (tabs[index]) {
					targetTab = tabs[index];
					console.log('Tab trovata per indice:', targetTab);
				}
			}
			
			if (!targetTab) {
				return;
			}
		}
		
		// Rimuovi active da tutte le tab
		document.querySelectorAll('.tabHash .nav-link').forEach(tab => {
			tab.classList.remove('active');
		});
		
		// Rimuovi active da tutti i tab-pane
		document.querySelectorAll('.tab-pane').forEach(pane => {
			pane.classList.remove('show', 'active');
		});
		
		// Attiva la tab corretta
		targetTab.classList.add('active');
		
		// Attiva il tab-pane corrispondente
		const targetPane = document.querySelector(targetHash);
		if (targetPane) {
			targetPane.classList.add('show', 'active');
			console.log('✅ Tab-pane attivato:', targetHash);
			
			// Aggiorna l'URL se necessario
			if (window.location.hash !== targetHash) {
				if (history.replaceState) {
					history.replaceState(null, null, window.location.pathname + targetHash);
				} else {
					window.location.hash = targetHash;
				}
			}
			
			// Pulisci sessionStorage dopo l'uso
			sessionStorage.removeItem('tabHash');
			
			// Scroll ottimizzato con offset header SOLO se richiesto esplicitamente
			if (shouldScroll) {
				setTimeout(() => {
					const headerOffset = getHeaderOffset();
					const targetElement = document.querySelector('.contacts-tab-navi') || targetPane;
					const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
					const scrollToPosition = Math.max(0, elementTop - headerOffset);
					
					window.scrollTo({
						top: scrollToPosition,
						behavior: 'smooth'
					});
				}, 100);
			}
		} else {
			console.log('❌ Tab-pane non trovato per:', targetHash);
		}
	};

	// Attiva la tab al caricamento della pagina con più tentativi
	const initWithRetry = () => {
		console.log('initWithRetry chiamato');
		console.log('window.location.hash:', window.location.hash);
		console.log('sessionStorage.tabHash:', sessionStorage.getItem('tabHash'));
		
		if (window.location.hash || sessionStorage.getItem('tabHash')) {
			console.log('Tentativo di attivazione tab iniziale');
			// Non fare scroll automatico al caricamento della pagina
			activateTabFromHash(null, false);
			
			// Riprova dopo un breve delay se non ha funzionato
			setTimeout(() => {
				const currentHash = window.location.hash || sessionStorage.getItem('tabHash');
				if (currentHash && !document.querySelector('.tabHash .nav-link.active')) {
					console.log('Secondo tentativo di attivazione tab');
					activateTabFromHash(null, false);
				}
			}, 500);
		} else {
			console.log('Nessun hash presente nell\'URL o sessionStorage');
		}
	};
	
	// Inizializza immediatamente e anche dopo un delay
	console.log('Chiamando initWithRetry immediatamente');
	initWithRetry();
	
	console.log('Programmando initWithRetry con timeout');
	setTimeout(() => {
		console.log('initWithRetry con timeout eseguito');
		initWithRetry();
	}, 100);

	// Gestisci i click sulle tab (sia link che button)
	console.log('Impostando event listeners per le tab');
	const tabLinks = document.querySelectorAll('.tabHash .nav-link');
	console.log('Tab trovate:', tabLinks.length);
	
	tabLinks.forEach((tab, index) => {
		tab.addEventListener('click', function(e) {
			e.preventDefault();
			
			// Determina l'hash basato sull'attributo o sulla posizione
			let hash = tab.getAttribute('href') || tab.getAttribute('data-target');
			
			// Se non ha attributi, usa l'indice per determinare l'hash
			if (!hash) {
				const indexToHash = [
					'#request-info',
					'#send-reports', 
					'#contact-offices',
					'#contact-facilities'
				];
				hash = indexToHash[index];
			}
			
			console.log('Cliccato tab con hash:', hash);
			
			if (!hash) {
				console.log('Impossibile determinare hash per tab');
				return;
			}
			
			// Aggiorna l'URL
			if (history.pushState) {
				history.pushState(null, null, window.location.pathname + hash);
			} else {
				window.location.hash = hash;
			}
			
			// Attiva la tab CON scroll ottimizzato (click esplicito dell'utente)
			setTimeout(() => {
				activateTabFromHash(hash, true);
			}, 10);
		});
	});

	// Gestisci i cambiamenti di hash (navigazione avanti/indietro)
	window.addEventListener('hashchange', () => {
		console.log('Hash cambiato:', window.location.hash);
		// Non fare scroll automatico per navigazione browser
		activateTabFromHash(null, false);
	});

	// Scroll orizzontale automatico per mobile
	const breakpoint = {
		desktop: 768
	};
	const isDesktop = window.innerWidth > breakpoint.desktop;
	
	if (!isDesktop) {
		setTimeout(() => {
			const activeTab = document.querySelector('.tabHash .nav-link.active');
			if (activeTab) {
				const activeTabLeft = activeTab.offsetLeft;
				const responsiveTabs = document.querySelector('.responsive-tabs');
				if (responsiveTabs) {
					responsiveTabs.scrollLeft = activeTabLeft - 15;
				}
			}
		}, 300);
	}
	
	console.log('tabHash setup completato');
};

// Script globale per intercettare i link con hash prima del redirect
document.addEventListener('DOMContentLoaded', function() {
	// Intercetta i click sui link con hash per le tab
	document.addEventListener('click', function(e) {
		const link = e.target.closest('a[href*="#"]');
		if (link) {
			const href = link.getAttribute('href');
			const url = new URL(href, window.location.origin);
			
			// Se il link porta alla stessa pagina ma con un hash diverso
			if (url.pathname === window.location.pathname && url.hash) {
				// Controlla se l'hash corrisponde a una tab
				const tabExists = document.querySelector(`.tabHash a[href="${url.hash}"]`) ||
								  document.querySelector(`.tabHash button[data-target="${url.hash}"]`) ||
								  document.querySelector(`.tabHash button[href="${url.hash}"]`);
				if (tabExists) {
					console.log('📝 Salvando hash in sessionStorage:', url.hash);
					sessionStorage.setItem('tabHash', url.hash);
				}
			}
		}
	});
	
	// Anche per i link nel menu che portano alla pagina contatti con hash
	document.addEventListener('click', function(e) {
		const link = e.target.closest('a[href*="/contatti/#"]');
		if (link) {
			const href = link.getAttribute('href');
			const hashMatch = href.match(/#(.+)$/);
			if (hashMatch) {
				console.log('📝 Salvando hash del menu in sessionStorage:', hashMatch[0]);
				sessionStorage.setItem('tabHash', hashMatch[0]);
			}
		}
	});
});

export default tabHash;